import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
//import mixpanel from 'mixpanel-browser';

import AppFooter from '../app-footer';
import AppHeader from '../app-header';

import ScrollToTop from '../scroll-to-top';
import { actions } from '../../actions';
import '../../index.css';
import asyncComponent from '../async'

import axios from 'axios';

const ThankYouPage = asyncComponent(() =>
    import('../../routes/thank-you').then(module => module.default)
)

const ListsPage = asyncComponent(() =>
    import('../../routes/lists-page').then(module => module.default)
)

const MessagePage = asyncComponent(() =>
    import('../../routes/message').then(module => module.default)
)

const EventsPage = asyncComponent(() =>
    import('../../routes/events-page').then(module => module.default)
)

const IndexPage = asyncComponent(() =>
    import('../../routes/index-page').then(module => module.default)
)

const MagazinePage = asyncComponent(() =>
    import('../../routes/magazine-page').then(module => module.default)
)

const MagazineSamplePage = asyncComponent(() =>
    import('../../routes/magazine-sample-page').then(module => module.default)
)

const ResourcesPage = asyncComponent(() =>
    import('../../routes/resources-page').then(module => module.default)
)

const TopicsPage = asyncComponent(() =>
    import('../../routes/topics-page').then(module => module.default)
)

const DEIPage = asyncComponent(() =>
	import('../../routes/dei-page').then(module => module.default)
)

const VideosIndexPage = asyncComponent(() =>
    import('../../routes/videos-index-page').then(module => module.default)
)

const WebinarIndexPage = asyncComponent(() =>
    import('../../routes/webinar-page').then(module => module.default)
)

const WebinarSinglePage = asyncComponent(() =>
    import('../../routes/webinar-single-page').then(module => module.default)
)

const MicrositeSinglePage = asyncComponent(() =>
    import('../../routes/microsite-single-page').then(module => module.default)
)

const LoginPage = asyncComponent(() =>
    import('../../routes/login-page').then(module => module.default)
)

const LogoutPage = asyncComponent(() =>
    import('../../routes/logout-page').then(module => module.default)
)

const RegisterPage = asyncComponent(() =>
    import('../../routes/register-page').then(module => module.default)
)

const ProfilePage = asyncComponent(() =>
    import('../../routes/profile-page').then(module => module.default)
)

const ProfilePasswordPage = asyncComponent(() =>
    import('../../routes/profile-password-page').then(module => module.default)
)

const DeleteUserPage = asyncComponent(() =>
    import('../../routes/delete-user-page').then(module => module.default)
)

const NewsletterPage = asyncComponent(() =>
    import('../../routes/newsletter-page').then(module => module.default)
)

const ArticleSingleContainer = asyncComponent(() =>
    import('../../routes/article-single-container').then(module => module.default)
)

const BlogHomePage = asyncComponent(() =>
    import('../../routes/blog-home-page').then(module => module.default)
)

const BlogSingleContainer = asyncComponent(() =>
    import('../../routes/blog-single-container').then(module => module.default)
)

const SendPreviewBoostPage = asyncComponent(() =>
    import('../../routes/preview_boost-page').then(module => module.default)
)

const TopicsSinglePage = asyncComponent(() =>
    import('../../routes/topics-single-page').then(module => module.default)
)

const SinglePage = asyncComponent(() =>
    import('../../routes/single-page').then(module => module.default)
)

const Top20SalesTrainingCompanies = asyncComponent(() =>
    import('../../routes/top-20-sales-training-companies').then(module => module.default)
)

const Top25SalesTrainingCompanies = asyncComponent(() =>
    import('../../routes/top-25-sales-training-companies').then(module => module.default)
)

const Top31SalesTrainingCompanies = asyncComponent(() =>
    import('../../routes/top-31-sales-training-companies').then(module => module.default)
)

const Top30SalesTrainingCompanies = asyncComponent(() =>
    import('../../routes/top-30-sales-training-companies').then(module => module.default)
)

const DEIinSales = asyncComponent(() =>
    import('../../routes/dei-in-sales').then(module => module.default)
)

const Top17VirtualSalesTrainingCompanies = asyncComponent(() =>
	import('../../routes/top-17-virtual-sales-training-companies').then(module => module.default)
)

const Top19VirtualSalesTrainingCompanies = asyncComponent(() =>
	import('../../routes/top-19-virtual-sales-training-companies').then(module => module.default)
)

const Top20OnlineSalesTrainingCompanies = asyncComponent(() =>
    import('../../routes/top-20-online-sales-training-companies').then(module => module.default)
)

const Top20VirtualSalesTrainingCompanies = asyncComponent(() =>
    import('../../routes/top-20-virtual-sales-training-companies').then(module => module.default)
)

const TopSalesEnablementVendor = asyncComponent(() =>
    import('../../routes/top-sales-enablement-vendor').then(module => module.default)
)

const Top5SalesEnablementVendors = asyncComponent(() =>
    import('../../routes/top-5-sales-enablement-vendors').then(module => module.default)
)

const Top10SalesEnablementVendors = asyncComponent(() =>
    import('../../routes/top-10-sales-enablement-vendors').then(module => module.default)
)

const Top15SalesEnablementVendors = asyncComponent(() =>
    import('../../routes/top-15-sales-enablement-vendors').then(module => module.default)
)

const TopAISalesCoachingSolutions = asyncComponent(() =>
    import('../../routes/top-ai-sales-coaching-solutions').then(module => module.default)
)

const TopAISolutionsforSales = asyncComponent(() =>
    import('../../routes/top-ai-solutions-for-sales').then(module => module.default)
)

const Top10AISolutionsforSales = asyncComponent(() =>
    import('../../routes/top-10-ai-solutions-for-sales').then(module => module.default)
)

const SixtyBestCompanies = asyncComponent(() =>
    import('../../routes/60-best-companies').then(module => module.default)
)

const FiftyBestCompanies = asyncComponent(() =>
    import('../../routes/50-best-companies').then(module => module.default)
)

const SellingPower500 = asyncComponent(() =>
    import('../../routes/selling-power-500').then(module => module.default)
)

const LargestSellingPower500 = asyncComponent(() =>
    import('../../routes/largest-sales-organizations-selling-power-500').then(module => module.default)
)

const AmericasBestSalesSpeakersPage = asyncComponent(() =>
	import('../../routes/americas-best-sales-speakers').then(module => module.default)
)

const RevenueEnablementExcellenceAwardsPage = asyncComponent(() =>
    import('../../routes/revenue-enablement-excellence-awards').then(module => module.default)
)

const SalesEnablementExcellenceAwardsPage = asyncComponent(() =>
    import('../../routes/sales-enablement-excellence-awards').then(module => module.default)
)

const CROoftheYearAwardsPage = asyncComponent(() =>
    import('../../routes/cro-of-the-year-awards').then(module => module.default)
)

const LeadingSalesConsultantsPage = asyncComponent(() =>
    import('../../routes/leading-sales-consultants').then(module => module.default)
)

const RecommendedSalesConsultantsPage = asyncComponent(() =>
    import('../../routes/recommended-sales-consultants').then(module => module.default)
)

const SalesConsultantsPage = asyncComponent(() =>
    import('../../routes/sales-consultants').then(module => module.default)
)

const SalesEnablementConsultantsPage = asyncComponent(() =>
    import('../../routes/sales-enablement-consultants').then(module => module.default)
)

const RecommendedBooks = asyncComponent(() =>
    import('../../routes/recommended-books').then(module => module.default)
)

const RecommendedSalesBooks = asyncComponent(() =>
    import('../../routes/recommended-sales-books').then(module => module.default)
)

const SalesTrainingIndustryPage = asyncComponent(() =>
    import('../../routes/sales-training-industry').then(module => module.default)
)

const AIExpertInsightPage = asyncComponent(() =>
    import('../../routes/ai-expert-insight').then(module => module.default)
)

const SalesJobs = asyncComponent(() =>
    import('../../routes/sales-jobs').then(module => module.default)
)

const WhitePapersPage = asyncComponent(() =>
    import('../../routes/white-papers-page').then(module => module.default)
)

const BlogsPage = asyncComponent(() =>
    import('../../routes/blogs-page').then(module => module.default)
)

const SearchPage = asyncComponent(() =>
    import('../../routes/search-page').then(module => module.default)
)

const FourOhFour = asyncComponent(() =>
    import('../../routes/404').then(module => module.default)
)

const ForgotPasswordPage = asyncComponent(() =>
    import('../../routes/forgot-password-page').then(module => module.default)
)

const ResetPasswordPage = asyncComponent(() =>
    import('../../routes/reset-password-page').then(module => module.default)
)

const MagazineSubscribePage = asyncComponent(() =>
    import('../../routes/magazine-subscribe-page').then(module => module.default)
)

const MediaKit = asyncComponent(() =>
    import('../../routes/media-kit').then(module => module.default)
)

const AdvertisingPage = asyncComponent(() =>
    import('../../routes/advertising').then(module => module.default)
)

const NancyNardinPage = asyncComponent(() =>
    import('../../routes/nancy-nardin-page').then(module => module.default)
)

window.previousLocation=[];
window.previousLocation='direct';    

const { getUser, getUserNewsSub, logoutUser } = actions;

class App extends Component {
    constructor() {
        super();

        this.state = {
            footerSection: false,
			mypagetype:"",
		    myfootermenu:'',
			myheadermenu:''

        }
    } 

    componentWillReceiveProps() {
        window.previousLocation = this.props.location.pathname;
    }

    componentWillMount() {
        const {
            getMagazineCurrentIssue
        } = this.props;

        getMagazineCurrentIssue();
    }
        
    componentDidMount() {
        /*mixpanel.init('ca66339f904562fa8f29695c543838bf');
        mixpanel.track("App rendered");*/

		this.getWpHeaderMenu();
		this.getMyFooterMenu();
		
        if (!this.props.token) return;

        this.props.getUser()
        .then(this.props.getUserNewsSub())
        .catch((error) => {
            console.log(error);

            if (typeof error.response !== 'undefined' && error.response.status === 401) {
                this.props.history.push('/logout');
            }
        });
    }

	
	getWpHeaderMenu() {
		let wheretogoforthis=window.location.hostname.replace(':'+window.location.port,'');
		let imgoing='https://'+wheretogoforthis+'/myheader_menu?site=p';		
		if (wheretogoforthis.includes("localhost")) {
			imgoing='http://'+wheretogoforthis+'/myheader_menu?site=p';
		} else {
			imgoing='https://'+wheretogoforthis+'/myheader_menu?site=p';
		}
		axios.get(imgoing)
         .then((response) => {
		  	this.setState({
				myheadermenu: response.data
			});	
       })
         .catch((error) => {
             console.log('Err', error, error.response);
             if(error.response && error.response.status === 404) this.setState({errorLoading: true});
         });
  }
		  
	
	 getMyFooterMenu(){ 
		 let wheretogoforthis=window.location.hostname.replace(':'+window.location.port,'');
		 let imgoing='https://'+wheretogoforthis+'/myfooter_menu?site=p';		 
		 if (wheretogoforthis.includes("localhost")) {
			 imgoing='http://'+wheretogoforthis+'/myfooter_menu?site=p';
		 } else {
			 imgoing='https://'+wheretogoforthis+'/myfooter_menu?site=p';
		 }
		 axios.get(imgoing)
			 .then((response) => {
			 this.setState({
			 	myfootermenu:response.data
			 });	
		 })
			 .catch((error) => {
			 console.log('Err', error, error.response);
			 if(error.response && error.response.status === 404) this.setState({errorLoading: true});
		 });
	 }
	
	
	
    render() {
        return (
            <ScrollToTop>
                <div className="App">
                    <Helmet titleTemplate="%s / Selling Power">
                        <meta property="og:url" content={'https://www.sellingpower.com' + window.location.pathname} />
                    </Helmet>

                    <AppHeader myheadermenu={this.state.myheadermenu}/>

                    <Switch>
                        <Route exact path='/message' component={MessagePage} />
                        <Route exact path='/' component={IndexPage} />
                        <Route exact path='/webinars' component={WebinarIndexPage} />
                        <Route path='/webinars/:id/:slug' component={WebinarSinglePage} />
                        <Route exact path='/videos' component={VideosIndexPage} />
                        <Route path='/videos/category/:category_id/:category_slug' component={VideosIndexPage} />
                        <Route path='/videos/:video_id/:slug' component={VideosIndexPage} />
                        <Route exact path='/events' component={EventsPage} />
                        <Route exact path='/topics' component={TopicsPage} />
                        <Route path='/topics/:id/:name' component={TopicsSinglePage} />
                        <Route exact path='/dei' component={DEIPage} />
                        <Route exact path='/magazine' component={MagazinePage} />
                        <Route exact path='/magazine/sample' component={MagazineSamplePage} />
                        <Route exact path='/magazine/subscribe/' component={MagazineSubscribePage} />
                        <Route exact path='/magazine/subscribe/:sp_code' component={MagazineSubscribePage} />
                        <Route exact path='/resources' component={ResourcesPage} />
                        <Route exact path='/blog/:slug' component={BlogSingleContainer} />
                        <Route exact path='/blog' component={BlogHomePage} />
                        <Route exact path='/blogs' component={BlogsPage} />
                        <Route exact path='/login' component={LoginPage} />
                        <Route exact path='/register' component={RegisterPage} />
                        <Route exact path='/profile' component={ProfilePage} />
                        <Route exact path='/profile/password' component={ProfilePasswordPage} />
                        <Route exact path='/profile/delete' component={DeleteUserPage} />
                        <Route exact path='/newsletters' component={NewsletterPage} />
                        <Route exact path='/forgot-password' component={ForgotPasswordPage} />
                        <Route exact path='/reset-password' component={ResetPasswordPage} />
                        <Route exact path='/boost-preview' component={SendPreviewBoostPage} />    
                        <Route exact path='/advertising' render={() => <AdvertisingPage id={12640} />} />
                        <Route exact path='/advertising/media-kit' render={(props) => <MicrositeSinglePage {...props} client="Selling Power" title="Media-Kit" />} />
                        <Route exact path='/advertising/mediakit' component={MediaKit} />
                        <Route exact path='/submissions' render={() => <SinglePage id={12644} />} />
                        <Route exact path='/reprints' render={() => <SinglePage id={12647} />} />
                        <Route exact path='/contact' render={() => <SinglePage id={12650} />} />
                        <Route exact path='/about' render={() => <SinglePage id={12660} />} />
                        <Route exact path='/privacy-policy' render={() => <SinglePage id={12732} />} />
                        <Route exact path='/thank-you/newsletters/' render={() => <ThankYouPage id={19161} />} />
                        <Route exact path='/thank-you/registration/' render={() => <ThankYouPage id={19163} />} />    
                        <Route exact path='/thank-you/magazine/' render={() => <ThankYouPage id={19159} />} />    
                        <Route exact path='/nancy-nardin' render={() => <NancyNardinPage id={14925} />} />
                        <Route exact path='/sp500' render={() => <SinglePage id={13020} />} />
                        <Route exact path='/lists/2022/cro-of-the-year-awards/apply' render={(props) => <MicrositeSinglePage {...props} client="Selling Power" title="2022-cro-of-the-year-awards" />} />
                        <Route exact path='/lists/2023/dei-in-sales/apply' render={(props) => <MicrositeSinglePage {...props} client="Selling Power" title="2023-dei-in-sales" />} />
                        <Route path='/lists/:year/selling-power-500' render={() => <SellingPower500 />} />
                        <Route path='/lists/:year/largest-sales-organizations-selling-power-500' render={() => <LargestSellingPower500 />} />
                        <Route exact path='/lists/2023/americas-best-sales-speakers/booking' render={(props) => <MicrositeSinglePage {...props} client="Selling Power" title="2023-americas-best-sales-speakers" />} />
                        <Route path='/lists/:year/americas-best-sales-speakers' render={() => <AmericasBestSalesSpeakersPage />} />	
                        <Route path='/sales-training-success-insight-for-:year' render={() => <SalesTrainingIndustryPage />} /> 
                        <Route path='/ai-for-sales-increase-revenue-:year-expert-insight' render={() => <AIExpertInsightPage />} /> 
                        <Route exact path='/resources/content/:title/:client' component={MicrositeSinglePage} />
                        <Route path='/resources/white-papers' component={WhitePapersPage} />    
                        <Route exact path='/resources/b2b-sales-jobs' render={() => <SalesJobs id={18512} />} />     
                        <Route path='/lists/:year/recommended-sales-consultants' render={() => <RecommendedSalesConsultantsPage />} />
                        <Route path='/lists/:year/revenue-enablement-excellence-awards' render={() => <RevenueEnablementExcellenceAwardsPage />} />    
                        <Route path='/lists/:year/sales-enablement-excellence-awards' render={() => <SalesEnablementExcellenceAwardsPage />} />    
                        <Route path='/lists/:year/cro-of-the-year-awards' render={() => <CROoftheYearAwardsPage />} />    
                        <Route path='/lists/:year/leading-sales-consultants' render={() => <LeadingSalesConsultantsPage />} />    
                        <Route path='/lists/:year/sales-consultants' render={() => <SalesConsultantsPage />} />
                        <Route path='/lists/:year/sales-enablement-consultants' render={() => <SalesEnablementConsultantsPage />} />
                        <Route path='/lists/:year/sales-training-companies-top-20' render={() => <Top20SalesTrainingCompanies />} />
                        <Route path='/lists/:year/top-20-sales-training-companies' render={() => <Top20SalesTrainingCompanies />} />
                        <Route path='/lists/:year/sales-training-companies-top-25' render={() => <Top25SalesTrainingCompanies />} />    
                        <Route path='/lists/:year/top-25-sales-training-companies' render={() => <Top25SalesTrainingCompanies />} />
                        <Route path='/lists/:year/sales-training-companies-top-31' render={() => <Top31SalesTrainingCompanies />} />    
                        <Route path='/lists/:year/sales-training-companies-top-30' render={() => <Top30SalesTrainingCompanies />} />  
                        <Route path='/lists/:year/dei-in-sales' render={() => <DEIinSales />} />    
                        <Route path='/lists/:year/top-20-online-sales-training-companies' render={() => <Top20OnlineSalesTrainingCompanies />} />					
						<Route path='/lists/:year/virtual-sales-training-companies-top-17' render={() => <Top17VirtualSalesTrainingCompanies />} />				
						<Route path='/lists/:year/virtual-sales-training-companies-top-19' render={() => <Top19VirtualSalesTrainingCompanies />} />
                        <Route path='/lists/:year/virtual-sales-training-companies-top-20' render={() => <Top20VirtualSalesTrainingCompanies />} />	
                        <Route path='/lists/:year/60-best-companies-to-sell-for' render={() => <SixtyBestCompanies />} />
                        <Route path='/lists/:year/50-best-companies-to-sell-for' render={() => <FiftyBestCompanies />} />
                        <Route path='/lists/:year/selling-power-500' render={() => <SellingPower500 />} />
                        <Route path='/lists/:year/top-sales-enablement-vendor' render={() => <TopSalesEnablementVendor />} />
                        <Route path='/lists/:year/top-5-sales-enablement-vendors' render={() => <Top5SalesEnablementVendors />} />
                        <Route path='/lists/:year/top-10-sales-enablement-vendors' render={() => <Top10SalesEnablementVendors />} />
                        <Route path='/lists/:year/top-15-sales-enablement-vendors' render={() => <Top15SalesEnablementVendors />} />
                        <Route path='/lists/:year/top-ai-sales-coaching-solutions' render={() => <TopAISalesCoachingSolutions />} />
                        <Route path='/lists/:year/top-10-ai-solutions-for-sales' render={() => <Top10AISolutionsforSales />} />
                        <Route path='/lists/:year/top-ai-solutions-for-sales' render={() => <TopAISolutionsforSales />} />
                        <Route path='/lists/:year/recommended-sales-books' render={() => <RecommendedSalesBooks />} />    
                        <Route path='/lists/:year/recommended-books' render={() => <RecommendedBooks />} /> 
                        <Route exact path='/lists' component={ListsPage} />
                        <Route exact path='/resources/sales-consultants-letter' render={() => <SinglePage id={14590} />} />
                        <Route exact path='/resources/top-15-sales-enablement-partners-letter' render={() => <SinglePage id={14661} />} />
                        <Route path='/resources/:year/recommended-sales-consultants' render={() => <RecommendedSalesConsultantsPage />} />
                        <Route path='/resources/:year/sales-consultants' render={() => <SalesConsultantsPage />} />
                        <Route path='/resources/:year/sales-enablement-consultants' render={() => <SalesEnablementConsultantsPage />} />
                        <Route path='/resources/:year/top-20-sales-training-companies' render={() => <Top20SalesTrainingCompanies />} />
                        <Route path='/resources/:year/top-25-sales-training-companies' render={() => <Top25SalesTrainingCompanies />} />
                        <Route path='/resources/:year/top-20-online-sales-training-companies' render={() => <Top20OnlineSalesTrainingCompanies />} />
                        <Route path='/resources/:year/50-best-companies-to-sell-for' render={() => <FiftyBestCompanies />} />
                        <Route path='/resources/:year/selling-power-500' render={() => <SellingPower500 />} />
                        <Route path='/resources/:year/top-10-sales-enablement-vendors' render={() => <Top10SalesEnablementVendors />} />
                        <Route path='/resources/:year/top-15-sales-enablement-vendors' render={() => <Top15SalesEnablementVendors />} />
                        <Route path='/resources/:year/top-ai-sales-coaching-solutions' render={() => <TopAISalesCoachingSolutions />} />
                        <Route path='/resources/:year/top-10-ai-solutions-for-sales' render={() => <Top10AISolutionsforSales />} />
                        <Route path='/resources/:year/top-ai-solutions-for-sales' render={() => <TopAISolutionsforSales />} />
                        <Route path='/resources/:year/recommended-books' render={() => <RecommendedBooks />} /> 
                        <Route exact path='/:id/:slug' component={ArticleSingleContainer} />
                        <Route exact path='/:year/:month/:day/:id/:slug' component={ArticleSingleContainer} />
                        <Route path='/search' component={SearchPage} />
                        <Route exact path='/logout' render={() => <LogoutPage handleLogout={this.props.logoutUser} />} />
                        <Route path='' component={FourOhFour} />
                    </Switch>
		
		<AppFooter myfootermenu={this.state.myfootermenu} />
		
                </div>
            </ScrollToTop>
        );
    }
}

App.propTypes = {
    token: PropTypes.string,
    getUser: PropTypes.func,
    getUserNewsSub: PropTypes.func,
    logoutUser: PropTypes.func
};

export default connect(
    (state) => ({
        currentIssue: state.magazine.currentIssue,
        currentIssueLastFetched: state.magazine.currentIssueLastFetched
    }),
    { 
        getUser, 
        getUserNewsSub, 
        logoutUser,
        getMagazineCurrentIssue: actions.getMagazineCurrentIssue
    }
)(App);






// WEBPACK FOOTER //
// ./src/components/app/index.js